import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import image from "src/assets/images/wetez_validator_market.png";

export const WalletValidatorMarket = () => {
  return (
    <Box
      height="700px"
      p="0 170px 0 115px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack>
        <Typography
          variant="bold"
          fontSize="40px"
          color="white"
          alignSelf="flex-start"
          lineHeight="40px"
        >
          Validator market
        </Typography>

        <Typography
          color="secondary"
          fontSize="20px"
          lineHeight="20px"
          width="445px"
          mt="45px"
        >
          Popular validators are collected into Wetez wallet, to provides
          selection for delegators.
        </Typography>
      </Stack>

      <Box width="312px" height="554px">
        <img src={image} width="100%" height="100%" alt="market" />
      </Box>
    </Box>
  );
};
